<template>
    <v-layout row justify-center>
      <v-dialog v-model="showResetSector">
    <v-layout class="dialog-container" row justify-center>
      <v-card max-width="500">
        <v-card-title primary-title>
          <div>
            <h3 class="headline mb-0 primary--text">
              
            </h3>
            <h3 class="headline mb-0">Remover Ingressos Reservados?</h3>
          </div>
        </v-card-title>

        <v-card-text>
          <span
            class="grey--text"
          >Ao trocar de setor, você vai perder os ingressos reservados até o momento.</span>
        </v-card-text>

        <v-card-text>
          <span
            class="grey--text"
          >Deseja continuar mesmo assim?</span>
        </v-card-text>

        <v-card-actions class="px-4 pb-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" class="normal-text" flat outline round @click="closeDialog">Não, Manter a Compra</v-btn>
          <v-btn color="primary" class="normal-text" depressed round @click="reset"><span class="px-4 white--text">Sim</span></v-btn>
        </v-card-actions>
      </v-card>
    </v-layout>
  </v-dialog>
    </v-layout>
</template>

<script>
export default {
    data() {
        return {
        }
    },
    mounted() {
    },
    computed: {
        showResetSector() {
            return this.$store.getters.showResetSector;
        },
        tempSelectedSector() {
            return this.$store.getters.tempSelectedSector;
        },
        cartProducts() {
            return this.$store.getters.cartProducts;
        },
        sectorMap() {
            return this.$store.getters.sectorMap;
        },
    },
    methods: {
        closeDialog() {
            this.$store.dispatch('setResetSector', false);
        },
        async reset() {
          this.cartProducts.forEach(product => {
            product.forEach(async el => {
              let qtd = el.quantidade

              el.seats.forEach (async sh => {
                let selectedSeat = this.sectorMap.filter(fe => fe.codigo_assento === sh)
                selectedSeat[0].op = false
                await this.$store.dispatch('setSelectedSeat', selectedSeat[0])
              })
              for (var i = 0; i < qtd; i++) {
                await this.$store.dispatch('removeCartProduct', el);
              }
              
            })
            });
            await this.$store.dispatch('setResetSector', false);
            await this.$store.dispatch('setSelectedSector', this.tempSelectedSector);
        }
    }
}
</script>